"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Setting = function Setting() {
  return _react2.default.createElement(
    "g",
    { id: "setting" },
    _react2.default.createElement("path", {
      d: "M444.1,246.2 C444.1,236.2 443.1,226.5 441.7,217 L499.4,183.7 L428.6,61.2 L373.8,94.4 C358.6,82.2 343.5,72.4 325.8,65.2 L325.8,2 L184.4,2 L184.4,65.2 C166.7,72.4 146.1,82.3 131,94.4 L72,61.2 L0.6,183.7 L58,217 C56.6,226.6 55.4,236.3 55.4,246.2 C55.4,256.1 56.3,265.8 57.7,275.4 L0,308.7 L70.7,431.2 L131,398 C146.2,410.2 166.8,420 184.5,427.2 L184.5,497 L325.9,497 L325.9,427.2 C343.6,420 358.7,410.1 373.9,398 L430,431.2 L500,308.7 L442,275.4 C443.4,265.9 444.1,256.2 444.1,246.2 L444.1,246.2 Z M249.6,334.6 C200.8,334.6 161.2,295 161.2,246.2 C161.2,197.4 200.8,157.8 249.6,157.8 C298.4,157.8 338,197.4 338,246.2 C338,295 298.4,334.6 249.6,334.6 L249.6,334.6 Z",
      id: "Shape"
    })
  );
};

exports.default = Setting;


//////////////////
// WEBPACK FOOTER
// ./~/nitro-components/build/nitro/nitro-icon/Icons/Settings.js
// module id = 2986
// module chunks = 4